"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedAmount = void 0;
var _react = _interopRequireDefault(require("react"));
var _amountHelper = require("../../utils/amount/amountHelper");
var _formattedAmountModule = _interopRequireDefault(require("./formatted-amount.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _currencySymbolMap = _interopRequireDefault(require("currency-symbol-map"));
var FormattedAmount = function FormattedAmount(_ref) {
  var valueInCents = _ref.valueInCents,
    currency = _ref.currency,
    valueClassName = _ref.valueClassName,
    currencyClassName = _ref.currencyClassName,
    _ref$useSymbol = _ref.useSymbol,
    useSymbol = _ref$useSymbol === void 0 ? false : _ref$useSymbol;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: _formattedAmountModule.default['formatted-amount']
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_formattedAmountModule.default['formatted-amount__currency'], useSymbol ? _formattedAmountModule.default['formatted-amount__currency--symbol'] : '', currencyClassName)
  }, useSymbol ? (0, _currencySymbolMap.default)(currency) : currency), ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_formattedAmountModule.default['formatted-amount__value'], valueClassName)
  }, valueInCents !== undefined ? (0, _amountHelper.formatAmountInCents)(valueInCents) : '-'));
};
exports.FormattedAmount = FormattedAmount;